export default __webpack_public_path__ + "static/mortgage-white-6bb779f3a4c0ea3b871362fb096b8759.svg";